import { useLanguageStore } from "shared/translations/stores/languageStore";
import { useHttpClient, type SuccessResponse } from "./httpClient";
import { storeToRefs } from "pinia";
import type { Translations } from "shared/translations/domain/translations";

export interface UpdateEntityApiOptions<T extends SuccessResponse> {
  url: string;
  translate: (translations: Translations) => UpdateEntityApiTranslations;
  processOk: (response: Response) => Promise<T>;
}

export interface UpdateEntityRequest<T> {
  id: string;
  entity: T;
}

export interface UpdateEntityApiTranslations {
  title: string;
  error: string;
}

export function useUpdateEntityApi<TRequest, TResponse extends SuccessResponse>(
  options: UpdateEntityApiOptions<TResponse>) {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute
  };

  async function execute(action: UpdateEntityRequest<TRequest>) {

    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`${options.url}/${action.id}`), {
      method: 'PUT',
      headers,
      body: JSON.stringify(action.entity)
    });

    const text = options.translate(translations.value);

    const response = await httpClient.action<TResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      processOk: options.processOk
    });

    return response;
  }
}
